import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PostBeneficiaryAddressV4, PostBeneficiaryAddressV4Request} from 'domain/usecases';

export class RemotePostBeneficiaryAddressV4 implements PostBeneficiaryAddressV4 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<unknown>,
	) {}

	async post(params: PostBeneficiaryAddressV4Request): Promise<void> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
